import { currentWallet, getAddEthereumChainParameter } from '@amply-app/wallet';
import { useToast } from '@chakra-ui/react';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

export const useSwitchNetwork = (options: UseMutationOptions = {}) => {
  const isConnected = currentWallet.useIsConnected();
  const toast = useToast();

  return useMutation(async () => {
    const networkConfig = getAddEthereumChainParameter(
      Number(process.env.CHAIN_ID),
    );
    if (!isConnected) return;

    try {
      await currentWallet.connect(networkConfig);
    } catch (e: unknown) {
      toast({
        status: 'error',
        position: 'top',
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        description: (e as any)?.message ?? 'Error switching network',
      });
    }
  }, options);
};
